import { takeLatest, all, put, call } from 'redux-saga/effects';
import delay from '@redux-saga/delay-p';
import ResetPasswordPanelActions from './actions';

function* resetPasswordRequestHandler({ payload: { formRef, isValid } }) {
  if (!isValid) {
    yield call(delay, 500);
    yield put(ResetPasswordPanelActions.onResetPasswordFailure());
  } else {
    formRef.method = 'post';
    formRef.submit();
  }
}

function* resetPasswordFormSagas() {
  yield all([takeLatest(ResetPasswordPanelActions.onResetPasswordRequest.getType(), resetPasswordRequestHandler)]);
}

export default resetPasswordFormSagas;
